<router-outlet></router-outlet>
<!-- <div *ngIf="session">
    <app-publisher [session]="session"></app-publisher>
    <app-subscriber *ngFor="let stream of streams" [stream]="stream" [session]="session"></app-subscriber>
</div> -->
<!-- <div class="footer">
  Powered by DCT <a href="http://www.dct.construction" target="_blank">www.dct.construction</a>
</div> -->
